import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useHttp from "../../../hooks/use-http";
import { endPoints } from "../../../config/end-points";
import { useParams } from "react-router-dom";

const PollData = () => {
  const [pollData, setPollData] = useState({});
  const [poll2Data, setPoll2Data] = useState({});
  const [poll3Data, setPoll3Data] = useState({});
  const [pollResult, setPollResult] = useState({
    poll1: { option1: 0, option2: 0, option3: 0, option4: 0 },
    poll2: { option1: 0, option2: 0, option3: 0, option4: 0 },
    poll3: { option1: 0, option2: 0, option3: 0, option4: 0 },
  });
  const { camp_id } = useParams();
  const personalize_pollData = useSelector( (state) => state.personalize.personalize_pollData );
  const personalize_poll2Data = useSelector( (state) => state.personalize.personalize_poll2Data );
  const personalize_poll3Data = useSelector( (state) => state.personalize.personalize_poll3Data );
  const { sendRequest: fetchDataRequest } = useHttp();

  useEffect(() => {
    if (personalize_pollData) {
      setPollData(personalize_pollData);
    }

    if (personalize_poll2Data) {
      setPoll2Data(personalize_poll2Data);
    }

    if (personalize_poll3Data) {
      setPoll3Data(personalize_poll3Data);
    }

      fetchDataRequest(
        {
          url: endPoints.getPollData + "/" + camp_id,
          method: "GET",
        },
        (response) => {
          console.log(response)
          if (response.status === 200) {

              const pollCountsData = response.response.reduce((acc, curr) => {
                
                if (!acc[curr.poll_name]) {
                  acc[curr.poll_name] = { option1: 0, option2: 0, option3: 0, option4: 0 };
                }
                if (curr.option1 === 1) acc[curr.poll_name].option1 += 1;
                if (curr.option2 === 1) acc[curr.poll_name].option2 += 1;
                if (curr.option3 === 1) acc[curr.poll_name].option3 += 1;
                if (curr.option4 === 1) acc[curr.poll_name].option4 += 1;
                return acc;
              }, {});
            
            setPollResult(pollCountsData);
            // console.log(pollCountsData);
            // console.log(pollData);
            
            // const pollCountsData = Object.assign({},...response.data)
            // setPollResult(pollCountsData);
            // console.log(pollCountsData);
          }
        }
      );
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalize_pollData, personalize_poll2Data, personalize_poll3Data]);

  return (
    <>
      <div className="row justify-content-center">
        {pollData  && pollData.question && (
          <>
          <div className="col-4 mt-2">
            <div className="video_setting_left shadow2 bg-white p-3 h-100">
                <h3>{pollData.question}</h3>

                <ul className="custom_poll mt-2">
                  <li className=" bg-info text-light">
                    {pollData.option1}{" "}
                    {pollResult && (
                      <span className="pull-right ">
                        { (pollResult.poll1)?pollResult.poll1.option1:'0'} votes
                      </span>
                    )}
                  </li>
                  <li className=" bg-info text-light">
                    {pollData.option2}{" "}
                    {pollResult && (
                      <span className="pull-right">
                        { (pollResult.poll1)?pollResult.poll1.option2:'0'} votes
                      </span>
                    )}
                  </li>
                  {pollData.option3 && (
                    <li className=" bg-info text-light">
                      {pollData.option3}{" "}
                      {pollResult && (
                        <span className="pull-right">
                          { (pollResult.poll1)?pollResult.poll1.option3:'0'} votes
                        </span>
                      )}
                    </li>
                  )}
                </ul>
              
            </div>
          </div>
          </>
        )}
        {poll2Data && poll2Data.question && (
          <>
            <div className="col-4 mt-2">
              <div className="video_setting_left shadow2 bg-white p-3 h-100">
                <h3>{poll2Data.question}</h3>

                <ul className="custom_poll mt-2">
                  <li className=" bg-info text-light">
                    {poll2Data.option1}{" "}
                    {pollResult && (
                      <span className="pull-right ">
                        { (pollResult.poll2)?pollResult.poll2.option1:0} votes
                      </span>
                    )}
                  </li>
                  <li className=" bg-info text-light">
                    {poll2Data.option2}{" "}
                    {pollResult && (
                      <span className="pull-right">
                        { (pollResult.poll2)?pollResult.poll2.option2:0} votes
                      </span>
                    )}
                  </li>
                  <li className=" bg-info text-light">
                      {poll2Data.option3}{" "}
                      {pollResult && (
                        <span className="pull-right">
                          { (pollResult.poll2)?pollResult.poll2.option3:0} votes
                        </span>
                      )}
                  </li>
                  <li className=" bg-info text-light">
                      {poll2Data.option4}{" "}
                      {pollResult && (
                        <span className="pull-right">
                          { (pollResult.poll2)?pollResult.poll2.option4:0} votes
                        </span>
                      )}
                  </li>
                    
                </ul>
              </div>
            </div>
            </>
          )}
        {poll3Data && poll3Data.question && (
          <>
          <div className="col-4 mt-2">
            <div className="video_setting_left shadow2 bg-white p-3 h-100">
                <h3>{poll3Data.question}</h3>

                <ul className="custom_poll mt-2">
                  <li className=" bg-info text-light">
                    {poll3Data.option1}{" "}
                    {pollResult && (
                      <span className="pull-right ">
                        { (pollResult.poll3)?pollResult.poll3.option1:0} votes
                      </span>
                    )}
                  </li>
                  <li className=" bg-info text-light">
                    {poll3Data.option2}{" "}
                    {pollResult && (
                      <span className="pull-right">
                        { (pollResult.poll3)?pollResult.poll3.option2:0} votes
                      </span>
                    )}
                  </li>
                  <li className=" bg-info text-light">
                      {poll3Data.option3}{" "}
                      {pollResult && (
                        <span className="pull-right">
                          { (pollResult.poll3)?pollResult.poll3.option3:0} votes
                        </span>
                      )}
                  </li>
                  <li className=" bg-info text-light">
                      {poll3Data.option4}{" "}
                      {pollResult && (
                        <span className="pull-right">
                          { (pollResult.poll3)?pollResult.poll3.option4:0} votes
                        </span>
                      )}
                  </li>
                    
                </ul>
              </div>
            </div>
            </>
          )}


      </div>
    </>
  );
};

export default PollData;
